import { render, staticRenderFns } from "./journeyList.vue?vue&type=template&id=8f372320&scoped=true&"
import script from "./journeyList.vue?vue&type=script&lang=js&"
export * from "./journeyList.vue?vue&type=script&lang=js&"
import style0 from "./journeyList.vue?vue&type=style&index=0&id=8f372320&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f372320",
  null
  
)

export default component.exports